export const MAX_GROUP_NAME_LENGTH_LIMIT = 50;
export const MAX_SITES_LIMIT = 200;
